<template>
  <v-card>
    <v-card-title>
      <span class="subheading">Liste des étudiants</span>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Rechercher..."
        color="teal"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="students"
      :search="search"
      :loading="loading"
      :pagination.sync="pagination"
      rows-per-page-text="Résultats par page"
      :rows-per-page-items="[5, 10, 25]"
      :no-data-text="loading ? 'Chargement des données...' : 'Pas de données'"
      no-results-text="Aucun résultat pour les termes recherchés"
    >
      <template slot="headerCell" slot-scope="props">
        <div slot="activator" style="display: inline-block;">
          {{ props.header.text }}
        </div>
        <div v-if="props.header.text2" class="ml-3">
          {{ props.header.text2 }}
        </div>
      </template>
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.idisa }}</td>
        <td class="text-xs-left">{{ props.item.lastName }}</td>
        <td class="text-xs-left">{{ props.item.firstName }}</td>
        <td class="text-xs-left">
          {{ props.item.departement }} {{ props.item.mode | formatMode }}
        </td>
        <td class="justify-center px-0">
          <v-icon v-if="props.item.passwordChangedHesSo" color="teal lighten-1"
            >check_circle</v-icon
          >
          <v-icon v-else color="grey lighten-2">cancel</v-icon>
        </td>
        <td class="justify-center px-0">
          <v-icon v-if="props.item.hasEduID" color="teal lighten-1"
            >check_circle</v-icon
          >
          <v-icon v-else color="grey lighten-2">cancel</v-icon>
        </td>
        <td class="justify-center px-0">
          <v-icon v-if="props.item.codeOfConductAccepted" color="teal lighten-1"
            >check_circle</v-icon
          >
          <v-icon v-else color="grey lighten-2">cancel</v-icon>
        </td>
        <td class="justify-center px-0">
          <v-icon v-if="props.item.ahesFin" color="teal lighten-1"
            >check_circle</v-icon
          >
          <v-icon v-else color="grey lighten-2">cancel</v-icon>
        </td>
        <td class="justify-center px-0">
          <v-icon
            v-if="props.item.equivalencySubmittedWish"
            color="teal lighten-1"
            >check_circle</v-icon
          >
          <v-icon v-else color="grey lighten-2">cancel</v-icon>
        </td>
        <td class="justify-center px-0">
          <v-icon v-if="props.item.equivalencySubmitted" color="teal lighten-1"
            >check_circle</v-icon
          >
          <v-icon v-else color="grey lighten-2">cancel</v-icon>
        </td>
        <td class="justify-center px-0">
          <v-icon
            v-if="props.item.langEquivalencySubmitted"
            color="teal lighten-1"
            >check_circle</v-icon
          >
          <v-icon v-else color="grey lighten-2">cancel</v-icon>
        </td>
        <td class="text-xs-left">
          {{ props.item.alohaInvitation | formatDate }}
        </td>
        <td class="justify-center px-0">
          <v-icon v-if="props.item.hasLoggedInAloha" color="teal lighten-1"
            >check_circle</v-icon
          >
          <v-icon v-else color="grey lighten-2">cancel</v-icon>
        </td>
        <td class="text-xs-right">
          <v-btn
            small
            flat
            :href="`${clientUri}/2026/load/${props.item.guid}`"
            target="_blank"
            class="teal--text text--darken-1"
            >Vue étudiant</v-btn
          >
          <!-- <span v-if="$keycloak.hasResourceRole('admin', 'aloha-admin-app')">|</span>
          <v-btn
            small
            flat
            target="_blank"
            class="teal--text text--darken-1"
            @click="openModal(props.item)"
            v-if="$keycloak.hasResourceRole('admin', 'aloha-admin-app')"
          >Relancer</v-btn> -->
        </td>
      </template>
      <template v-slot:actions-append>
        <v-menu v-model=menu :close-on-content-click="false" :nudge-width="300" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-tooltip top>
              <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                <v-btn
                    icon
                    v-bind="{ ...attrs, ...tooltipAttrs }"
                    v-on="{ ...on, ...tooltipOn }"
                    @click.stop="menu = !menu"
                >
                  <v-icon class="material-icons-outlined">cloud_download</v-icon>
                </v-btn>
              </template>
              <span>Exports XLSX</span>
            </v-tooltip>
          </template>
          <v-card>
            <v-list>
              <v-list-tile @click="exportToCsv">
                <v-list-tile-content>
                  <v-list-tile-title>Liste Etudiant</v-list-tile-title>
                  <v-list-tile-sub-title>Exporte les données bruts</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon>download</v-icon>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile @click="exportCompletion">
                <v-list-tile-content>
                  <v-list-tile-title>Rapport de Complétion</v-list-tile-title>
                  <v-list-tile-sub-title>Informations de complétion de l'accueil</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon>download</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
        <!-- <v-tooltip top v-if="$keycloak.hasResourceRole('admin', 'aloha-admin-app')">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="openGroupReminderModal()" class="ma-2">
              <v-icon>alternate_email</v-icon>
            </v-btn>
          </template>
          <span>Relance groupée</span>
        </v-tooltip> -->
        <!-- <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="exportIssues" class="ma-2">
              <v-icon>error_outline</v-icon>
            </v-btn>
          </template>
          <span>Rapport d'erreurs</span>
        </v-tooltip>-->
      </template>
      <template v-slot:pageText="props"
        >Lignes {{ props.pageStart }} - {{ props.pageStop }} de
        {{ props.itemsLength }}</template
      >
    </v-data-table>
  </v-card>
</template>

<script>
import { filters } from '../mixins';

export default {
  mixins: [filters],
  props: [
    'students',
    'loading',
    'exportToCsv',
    'exportCompletion',
    'exportIssues',
    'openModal',
    'openGroupReminderModal',
  ],
  data: () => ({
    search: '',
    clientUri: process.env.VUE_APP_CLIENT_URI,
    pagination: {
      rowsPerPage: 10,
      sortBy: 'lastName',
    },
    headers: [
      { text: 'IDISA', value: 'idisa' },
      { text: 'Nom', value: 'lastName' },
      { text: 'Prénom', value: 'firstName' },
      { text: 'DptMod', value: 'departement' },
      {
        text: 'Mot de passe',
        value: 'passwordChangedHesSo',
        align: 'center',
        width: '7.5%',
      },
      {
        text: 'EduID',
        value: 'hasEduID',
        align: 'center',
        width: '7.5%',
      },
      {
        text: 'Savoir vivre',
        value: 'codeOfConductAccepted',
        align: 'center',
        width: '7.5%',
      },
      {
        text: 'AHES',
        value: 'ahesFin',
        align: 'center',
        width: '7.5%',
      },
      {
        text: 'Équivalence cours',
        text2: '(souhait)',
        value: 'equivalencySubmittedWish',
        align: 'center',
        width: '7.5%',
      },
      {
        text: 'Équivalence cours',
        text2: '(demande)',
        value: 'equivalencySubmitted',
        align: 'center',
        width: '7.5%',
      },
      {
        text: 'Équivalence langue',
        value: 'langEquivalencySubmitted',
        align: 'center',
        width: '7.5%',
      },
      { text: 'Invitation Aloha', value: 'lastConnection' },
      { text: 'Accès Aloha', value: 'hasLoggedInAloha' },
      { text: '', value: 'actions', align: 'right', sortable: false },
    ],
    menu: false
  }),
};
</script>